export default __webpack_public_path__ + "static/media/msg_info_background.bb19f114.svg";